/**
 * Focus slider – center product carousel (Tech Hunk Earbuds)
 * Rotates slides: center large, sides smaller; caption updates per active slide.
 */
(function () {
  const SECTION_SELECTOR = '.focus-slider[data-section-id]';

  function initSection(section) {
    if (section.dataset.focusReady === 'true') return;

    const track = section.querySelector('.focus-slider__track');
    const slides = track ? Array.from(track.querySelectorAll('.focus-slider__slide')) : [];
    const prev = section.querySelector('.focus-slider__nav--prev');
    const next = section.querySelector('.focus-slider__nav--next');
    const nameEl = section.querySelector('.focus-slider__name');
    const ctaEl = section.querySelector('.focus-slider__cta');
    const stage = section.querySelector('.focus-slider__stage');

    if (!slides.length) return;

    const autoplay = section.dataset.autoplay === 'true';
    const intervalMs = Math.max(2, parseInt(section.dataset.interval || '4', 10)) * 1000;
    const pauseOnHover = section.dataset.pauseHover === 'true';

    let index = 0;
    let timer = null;
    let touchStartX = null;

    function setClasses() {
      const count = slides.length;
      const leftIndex = (index - 1 + count) % count;
      const rightIndex = (index + 1) % count;

      slides.forEach((slide, idx) => {
        slide.classList.remove('is-left', 'is-center', 'is-right', 'is-far');

        if (idx === index) {
          slide.classList.add('is-center');
        } else if (idx === leftIndex) {
          slide.classList.add('is-left');
        } else if (idx === rightIndex) {
          slide.classList.add('is-right');
        } else {
          slide.classList.add('is-far');
        }
      });

      const active = slides[index];
      const title = active.dataset.title || '';
      const link = active.dataset.link || '#';

      if (nameEl) nameEl.textContent = title;
      if (ctaEl) ctaEl.href = link;
    }

    function go(direction) {
      index = (index + direction + slides.length) % slides.length;
      setClasses();
    }

    function startAutoplay() {
      stopAutoplay();
      if (!autoplay || slides.length <= 1) return;
      timer = setInterval(() => go(1), intervalMs);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function restartAutoplay() {
      stopAutoplay();
      startAutoplay();
    }

    setClasses();
    startAutoplay();

    if (prev) {
      prev.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        go(-1);
        restartAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        go(1);
        restartAutoplay();
      });
    }

    if (track) {
      track.addEventListener('click', (event) => {
        const img = event.target.closest('.focus-slider__slide img');
        if (!img) return;
        const slide = img.closest('.focus-slider__slide');
        const href = slide && slide.dataset.link;
        if (href && href !== '#') {
          window.location.assign(href);
        }
      });
    }

    if (stage) {
      stage.addEventListener(
        'touchstart',
        (event) => {
          touchStartX = event.touches[0].clientX;
          stopAutoplay();
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchend',
        (event) => {
          if (touchStartX === null) return;
          const delta = event.changedTouches[0].clientX - touchStartX;
          if (Math.abs(delta) > 40) {
            go(delta < 0 ? 1 : -1);
          }
          touchStartX = null;
          restartAutoplay();
        },
        { passive: true }
      );

      if (pauseOnHover) {
        stage.addEventListener('mouseenter', stopAutoplay, { passive: true });
        stage.addEventListener('mouseleave', startAutoplay, { passive: true });
      }

      stage.addEventListener('focusin', stopAutoplay);
      stage.addEventListener('focusout', startAutoplay);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopAutoplay();
      } else {
        startAutoplay();
      }
    });

    section.dataset.focusReady = 'true';
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section =
      event.target.querySelector(SECTION_SELECTOR) ||
      event.target.closest(SECTION_SELECTOR);
    if (section) {
      delete section.dataset.focusReady;
      initSection(section);
    }
  });
})();
